import type { RaceEntry } from '../types';

interface EntryRowProps {
  entry: RaceEntry;
  pending: boolean;
  onToggle: (userId: string, transport: boolean) => void;
}

/** Řádek závodníka – celý je klikací, přepínač je stylovaný checkbox. */
export function EntryRow({ entry, pending, onToggle }: EntryRowProps) {
  return (
    <li className={`entry${entry.transport ? ' entry--on' : ''}${pending ? ' entry--pending' : ''}`}>
      <label className="entry__row">
        <span className="entry__text">
          <span className="entry__name">
            {entry.lastName} {entry.firstName}
          </span>
          <span className="entry__meta">
            {entry.className && <span className="entry__class">{entry.className}</span>}
            {entry.regNo && <span className="entry__reg">{entry.regNo}</span>}
          </span>
        </span>

        <input
          className="entry__checkbox"
          type="checkbox"
          checked={entry.transport}
          disabled={pending}
          aria-label={`Doprava pro ${entry.firstName} ${entry.lastName}`}
          onChange={(event) => onToggle(entry.userId, event.target.checked)}
        />
        <span className="entry__switch" aria-hidden="true" />
      </label>
    </li>
  );
}
